import axios from "../httpHandler";

export const getProductBuys = async (filters) => {
  try {
    const result = await axios.get(`input/purchase${filters}`);
    return result?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getProductStatistics = async (filters) => {
  try {
    const result = await axios.get(`input/purchase/statistics${filters}`);
    return result?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const createProductBuy = async (data) => {
  return axios.post(`input/purchase`, {
    ...data,
    cost: parseInt((data?.cost ?? '0').replaceAll(',', '')),
    amount: parseInt((data?.amount ?? '0').replaceAll(',', '')),
  });
};
export const deleteProductBuy = async ({ id, warehouseSelected }) => {
  const queryParams = warehouseSelected ? '?update_warehouse' : '';
  return axios.delete(`input/purchase/${id}${queryParams}`);
};

export const updateProductBuy = (data) => {
  return axios.put(`input/purchase/${data?.id}`, {
    ...data,
    cost: parseInt((data?.cost ?? '0').replaceAll(',', '')),
    amount: parseInt((data?.amount ?? '0').replaceAll(',', '')),
  });
};
